import type { ReactNode } from "react";
import { cn } from "../lib/cn";


interface LinkButtonProps {
  href?: string;
  target?: React.HTMLAttributeAnchorTarget;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  children: ReactNode;
  className?: string;
}

const LinkButton = ({ children, href, target = "_self", onClick, className }: LinkButtonProps) => {
  return (
    <a
      href={href}
      target={target}
      onClick={onClick}
      className={cn(`link-button type-button hover:decoration-black hover:decoration-2 hover:underline-offset-4 whitespace-nowrap transition-all`, className)}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
    >
      {children}
    </a>
  );
};

export default LinkButton;